/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type RecordUpdateCategoryOverrideEntryInput = {
  categories?: Array<string> | null | undefined;
  composers?: Array<string> | null | undefined;
  to: string;
};

export type RecordUpdateOverrideEntryInput = {
  composers?: Array<string | number> | null | undefined;
  entityProperties?: Array<RecordUpdateOverridePropertyInput> | null | undefined;
  relationProperties?: Array<RecordUpdateOverridePropertyInput> | null | undefined;
};

export type RecordUpdateOverridePropertyInput = {
  key: string;
  template: string;
};

export type RecordUpdatePreserveOnMissingEvidenceEntryInput = {
  composers?: Array<string> | null | undefined;
  properties: Array<string>;
};

export type UpdateRecordUpdateComposerDefinitionInput = {
  categoryOverrides?: Array<RecordUpdateCategoryOverrideEntryInput> | null | undefined;
  overrides: Array<RecordUpdateOverrideEntryInput>;
  preserveOnMissingEvidence?: Array<RecordUpdatePreserveOnMissingEvidenceEntryInput> | null | undefined;
  recordUpdateComposerDefinitionId: string;
  tenantId: string;
};

export type UpdateRecordUpdateComposerDefinitionMutationVariables = Exact<{
  input: Types.UpdateRecordUpdateComposerDefinitionInput;
}>;


export type UpdateRecordUpdateComposerDefinitionMutation = { cnutUpdateRecordUpdateComposerDefinition: { __typename: 'UpdateRecordUpdateComposerDefinitionOutput', recordUpdateComposerDefinitionId: string } };


export const UpdateRecordUpdateComposerDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRecordUpdateComposerDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRecordUpdateComposerDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutUpdateRecordUpdateComposerDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordUpdateComposerDefinitionId"}}]}}]}}]} as unknown as DocumentNode<UpdateRecordUpdateComposerDefinitionMutation, UpdateRecordUpdateComposerDefinitionMutationVariables>;